// extracted by mini-css-extract-plugin
export default {"table_liste_pages":"liste-pages_table_liste_pages__0xX60","form_affichage_page":"liste-pages_form_affichage_page__v9OXe"};